import {InputSignal, InputSignalWithTransform} from '@angular/core';
import {TableRow}                              from '../../../../comps/table/table-wrapper/table-wrapper.component';
import {PanelMenuConfRowIntf} from './menu-crud-panel-top/menu-crud-tile/menu-crud-tile.component';

export abstract class MenuCrudPanelWrapperBase {
	abstract rows: InputSignal<TableRow<any>[] | undefined>;
	abstract conf: InputSignal<PanelMenuConfRowIntf[] | undefined>;
	abstract toggle: InputSignalWithTransform<boolean, unknown>;

}
